export function isToday(dateString: string): boolean {
  const today = new Date();
  const dateToCheck = new Date(dateString);

  // Convertimos ambas fechas a "YYYY-MM-DD" para comparar solo las partes de fecha
  const todayStr = today.toISOString().split("T")[0];
  const dateStr = dateToCheck.toISOString().split("T")[0];

  return todayStr === dateStr;
}

// Calcular la fecha futura a partir de un número de días
export function calculateFutureDate(days: number, date?: string): string {
  // Crear la fecha base: hoy o la proporcionada en formato "YYYY-MM-DD"
  const baseDate = date ? new Date(date) : new Date();

  // Añadir los días especificados
  baseDate.setDate(baseDate.getDate() + days);

  // Convertir a "YYYY-MM-DD" para obtener el formato deseado
  return baseDate.toISOString().split("T")[0];
}

export function formatFecha(fecha:string) {
  const meses = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  // Convertir la fecha de cadena a un objeto Date
  const date = new Date(`${fecha}T00:00:00Z`);

  // Obtener los componentes de la fecha
  const dia = date.getUTCDate(); // Usamos getUTCDate() en lugar de getDate()
  const mes = meses[date.getUTCMonth()]; // Usamos getUTCMonth() para evitar desajustes
  const año = date.getUTCFullYear();

  // Retornar en el formato deseado
  return `${mes} ${dia}, ${año}`;
}

export function esFechaFutura(fecha:string) {
  // Convertir la fecha proporcionada a un objeto Date
  const fechaIngresada = new Date(fecha);
  
  // Obtener la fecha actual y establecer la hora a 00:00:00 para solo comparar fechas
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  // Comprobar si la fecha ingresada es mayor que hoy
  return fechaIngresada > hoy;
}


export function formatFechaWithHour(fecha: string) {
  const meses = [
    "Ene", "Feb", "Mar", "Abr", "May", "Jun", 
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
  ];

  // Convertir la fecha de cadena a un objeto Date
  const date = new Date(fecha);

  // Obtener los componentes de la fecha
  const dia = date.getDate(); // Día del mes
  const mes = meses[date.getMonth()]; // Mes abreviado
  const año = date.getFullYear();
  const horas = date.getHours().toString().padStart(2, '0'); // Hora en formato 24h
  const minutos = date.getMinutes().toString().padStart(2, '0'); // Minutos con dos dígitos

  // Retornar en el formato deseado
  return `${mes} ${dia}, ${año}, ${horas}:${minutos}`;
}
